import { Component } from '@angular/core';

@Component({
  selector: 'app-frequently-asked-questions',
  templateUrl: './frequently-asked-questions.component.html',
  styleUrl: './frequently-asked-questions.component.scss',
})
export class FrequentlyAskedQuestionsComponent {
  items = [
    {
      title: 'هل يوجد مناطق اقتصادية بمصر؟',
      content:
        ' نعم يوجد منطقة اقتصادية وحيدة، وهى المنطقة الاقتصادية بشمال غرب خليج السويس، انشئت وتعمل في ظل احكام قانون رقم 83 لسنة 2002. ',
      expanded: false,
    },
    {
      title:
        'هل يجوز أن يكون رأسمال الشركات التي تؤسس داخل الهيئة بأية عملة حرة بخلاف الجنية المصري ؟',
      content:
        'يجوز أن يكون رأسمال الشركات التي تؤسس في الهيئة بالجنية المصري أو أيه عمله حرة فيما عدا الشركة ذات المسئولية المحدودة الخاضعة لأحكام القانون رقم 159 لسنة 1981 فيلزم أن يكون رأسمالها بالجنية المصري فقط.',
      expanded: false,
    },
    {
      title:
        'ما هى الحوافز و المزايا التى تقدمها المنطقة الاقتصادية شمال غرب خليج السويس؟',
      content:
        'طبقاً لقانون 83 لسنة 2002 تقدم المنطقة عدد من المزايا مقارنة بمثيلاتها من المناطق الاقتصادية العالمية. وهى كالاتي: 10% ضريبة عامة على الدخل 5% ضريبة كسب عمل 10% ضريبة عامة على الدخل',
      expanded: false,
    },
    {
      title:
        'هل يمكن الاستثمار في المنطقة الاقتصادية طبقاً لقانون ضمانات و حوافز الاستثمار (رقم 8 لسنة 1997)',
      content:
        'الاستثمار بالمنطقة الاقتصادية يتم وفقاً لقانون 83 لسنة 2002 الصادر بشأن المناطق الاقتصادية ذات الطبيعة الخاصة .',
      expanded: false,
    },
    {
      title: 'ما هى الصناعات المستهدفة للاستثمار في المنطقة الاقتصادية؟',
      content:
        'الصناعات المستهدفة في المنطقة هي المزيج من الصناعات المتوسطة والخفيفة, بما في ذلك؛ تجميع السيارات ومكوناتها, والمواد الكيميائية والبتروكيماويات والإنشاءات ومواد البناء والمنسوجات والملابس الجاهزة.',
      expanded: false,
    },
    {
      title:
        'هل يمكن لمطور اجنبي المشاركة في تطوير البنية الاساسية للمنطقة الاقتصادية؟',
      content:
        'نعم, ممكن تحقيق ذلك من خلال عقد مبرم بين ( المطور وشركة التنمية الرئيسية)  علماً بان شركة التنمية الرئيسة هي ذراع التطوير للهيئة العامة للمنطقة الاقتصادية و المسئولة عن تنفيذ و ادارة البنية الاساسية و المرافق داخل المنطقة.',
      expanded: false,
    },
    {
      title: 'ما هي الشروط الواجب توافرها فى شركة المساهمة ؟',
      content:
        'كي يكون الشكل القانونى لشركة المساهمة صحيحا وفقا لإحكام القانون يجب أن تتوافر فيها الشروط التالية : أن لايقل عدد المؤسسين بالشركة عن ثلاث أشخاص على الأقل ( طبيعيين حيث ان هذا الشرط مطلوب طوال فترة استمرار الشركة - اعتباريين) ممن تتوافر فيهم أهلية التأسيس. أن لايقل رأس المال عن 250 ألف جنيه كحد أدنى وأن يودع بالبنك 10% منه عند التأسيس على الأقل.',
      expanded: false,
    },
    {
      title:
        'ما هي الإجراءات التي يتطلبها القانون لتأسيس الشركات ذات المسئولية المحدودة ؟',
      content:
        'هناك إجراءات اشترط القانون رقم 159 لسنة 1981 توافرها لتأسيس الشركات ذات المسئولية المحدودة هي : ان لايقل عدد الشركاء المؤسسين بالشركة عن اثنين على الأقل ممن تتوافر فيهم الاهلية القانونية التأسيس عدم وجود حد ادني لرأسمالها بشرط ان تكون الحصص متساوية',
      expanded: false,
    },
    {
      title: 'هل يجوز لاى شخص الجمع بين اى عمل فى الحكومة او القطاع العام ؟',
      content:
        'يكون لموظفى الحكومة الحق فى تأسيس الشركة حالة الحصول على موافقة الوزير المختص وذلك بالنسبة لشركات المساهمة فقط طبقا للمادة 177 من القانون رقم 159 لسنة 1981. أما المحاسب فيجب عليه أولاً الحصول على موافقة سجل المحاسبين والمراجعين حيث لا يجوز لموظف الحكومة ان يكون شريك بالشركة وان المسئولية المحدودة او شريك متضامن بشركات الاشخاص يتعارض ذلك مع قانون العاملين بالدولة .',
      expanded: false,
    },
    {
      title: 'هل يجوز للقاصر الدخول كمساهم أو شريك بالشركات ؟',
      content:
        'فى شركات الأموال يجوز للقاصر الدخول فيها كمكتتب حال توافر شروط تأسيسها أما شركات الأشخاص فيجوز له الدخول فى شركات التوصية البسيطة كشريك موصى , ولايجوز له الدخول فى شركات التضامن بالنسبة للمنشآت الفردية فلا يجوز للقاصر إقامة منشأة فردية على الإطلاق الا فى حاله بلوغه سن 18 سنة وحصل على موافقه من المحكمة المختصة بالاذن له بالاتجار',
      expanded: false,
    },
  ];
  toggle(item: any) {
    item.expanded = !item.expanded;
  }

}
